import { withRedirect } from 'com-ui/hocs'

// Redirect to homepage when accessing NotFound page
export default withRedirect(() => null, '/')
